module.exports = "/assets/e6101764eb7fd5f0978ec76d0d49142a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MT.png
// module id = 2750
// module chunks = 0